var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCreditYellow = function SvgIconCreditYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 32,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_credit_yellow_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_credit_yellow_svg__b)",
    d: "m4.251 18.563 4.417 2.454-3.86.204-4.415-2.458z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m4.458 18.678-.207-.116-3.858.201.203.115h.009z",
    opacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_credit_yellow_svg__c)",
    d: "m14.62 0 4.417 2.457-4.602 11.488-4.416-2.457z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.62 0 10.02 11.488l.206.115L14.833.118z",
    opacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_credit_yellow_svg__d)",
    d: "m15.19 11.217 4.417 2.457L3.809 32l-1.87-1.032z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_credit_yellow_svg__e)",
    d: "M15.19 11.216 1.938 30.968l2.313-12.406-3.858.2 1.66-12.33L14.622 0l-4.602 11.488z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.19 11.217 1.938 30.967l.207.113.006.003 13.252-19.748z",
    opacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_credit_yellow_svg__f)",
    d: "M14.62 0 5.364 4.738l6.73 11.098 3.097-4.62-5.171.272z",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon_credit_yellow_svg__g)",
    d: "m4.824 26.669 3.643-5.431-6.88-11.35-1.194 8.875 3.858-.201-1.02 5.478z",
    opacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_credit_yellow_svg__b",
    x1: -7.912,
    x2: 2.894,
    y1: 22.227,
    y2: 20.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_credit_yellow_svg__c",
    x1: 18.48,
    x2: 13.022,
    y1: -2.401,
    y2: 10.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_credit_yellow_svg__d",
    x1: 23.631,
    x2: 7.617,
    y1: 5.166,
    y2: 23.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6F0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_credit_yellow_svg__e",
    x1: 5.62,
    x2: 17.471,
    y1: 9.225,
    y2: 37.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8E0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_credit_yellow_svg__f",
    x1: 7.414,
    x2: 13.806,
    y1: 11.629,
    y2: 5.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_credit_yellow_svg__g",
    x1: 6.853,
    x2: 1.691,
    y1: 12.452,
    y2: 21.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_credit_yellow_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.393 0h19.214v32H.393z"
  })))));
};
export default SvgIconCreditYellow;